
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component<TextInputButton>({})
export default class TextInputButton extends Vue {
	@Prop({ type: String, required: true }) readonly id!: string;
	@Prop({ type: String, required: true }) readonly value!: string;
	@Prop({ type: String, required: false, default: '' }) readonly placeholder!: string;
	@Prop({ type: String, required: false, default: '' }) readonly buttonLabel!: string;
	@Prop({ type: String, required: false, default: '' }) readonly label!: string;
	@Prop({ type: String, required: false, default: '' }) readonly buttonClass!: string;
	@Prop({ type: String, required: false, default: 'primary' }) readonly color!: string;
	@Prop({ type: String, required: false, default: '' }) readonly message!: string;
	@Prop({ type: String, required: false, default: '' }) readonly appliedLabel!: string;
	@Prop({ type: Boolean, required: false, default: false }) readonly applied!: boolean;
	@Prop({ type: Boolean, required: false, default: false }) readonly success!: boolean;
	@Prop({ type: Boolean, required: false, default: false }) readonly disabled!: boolean;
	@Prop({ type: Boolean, required: false, default: false }) readonly loading!: boolean;
	@Prop({ type: Number, required: false }) readonly maxLength!: number;

	private handleClick(event: MouseEvent): void {
		this.$emit('click', event);
	}
}
